export const money = (n, currency = "MXN") =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency, maximumFractionDigits: 0 }).format(n || 0);

export const num = (n) => new Intl.NumberFormat("es-MX").format(n || 0);

export const pad = (n, len) => String(n).padStart(Number.isInteger(len) && len > 0 ? len : 4, "0");
export const padFor = (raffle) => {
  const first = raffle?.number_start ?? 1;
  const len = Math.max(2, String(first + (raffle?.total_tickets || 1) - 1).length);
  return (n) => pad(n, len);
};

export const FALLBACK_IMG = "https://images.unsplash.com/photo-1513151233558-d860c5398176?w=1200&q=80";
export const raffleImg = (r) => (r?.gallery && r.gallery[0]) || FALLBACK_IMG;
export const onImgError = (e) => { if (e.target.src !== FALLBACK_IMG) e.target.src = FALLBACK_IMG; };


export const fmtDate = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleDateString("es-MX", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return d; }
};

export const fmtDateTime = (d) => {
  if (!d) return "";
  try {
    return new Date(d).toLocaleString("es-MX", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch { return d; }
};

export const timeAgo = (d) => {
  const diff = (Date.now() - new Date(d).getTime()) / 1000;
  if (diff < 60) return "hace unos segundos";
  if (diff < 3600) return `hace ${Math.floor(diff / 60)} min`;
  if (diff < 86400) return `hace ${Math.floor(diff / 3600)} h`;
  return `hace ${Math.floor(diff / 86400)} d`;
};

export const DELIVERY_STATUS = {
  Pendiente: "bg-slate-100 text-slate-600",
  "En proceso": "bg-amber-50 text-amber-700",
  Entregado: "bg-emerald-50 text-emerald-700",
};
export const deliveryLabel = (w) => {
  if (w.delivery_status === "Entregado" && w.delivered_at) {
    const d = new Date(`${w.delivered_at}T12:00:00`);
    return `Entregado · ${d.toLocaleDateString("es-MX", { day: "numeric", month: "short", year: "numeric" })}`;
  }
  return w.delivery_status || "Pendiente";
};

export const RAFFLE_STATUS = {
  draft: { label: "Borrador", cls: "bg-slate-100 text-slate-600" },
  scheduled: { label: "Programado", cls: "bg-blue-50 text-blue-700" },
  active: { label: "Activo", cls: "bg-emerald-50 text-emerald-700" },
  paused: { label: "Pausado", cls: "bg-amber-50 text-amber-700" },
  sold_out: { label: "Agotado", cls: "bg-slate-800 text-white" },
  preparing: { label: "En preparación", cls: "bg-violet-50 text-violet-700" },
  live: { label: "En vivo", cls: "bg-red-50 text-red-700" },
  finished: { label: "Finalizado", cls: "bg-slate-100 text-slate-500" },
  cancelled: { label: "Cancelado", cls: "bg-red-50 text-red-700" },
};

export const PAYMENT_STATUS = {
  pending: { label: "Pendiente", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  in_review: { label: "En revisión", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  correction_requested: { label: "Corrección solicitada", cls: "bg-orange-50 text-orange-700 border-orange-200" },
  approved: { label: "Aprobado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rechazado", cls: "bg-red-50 text-red-700 border-red-200" },
  cancelled: { label: "Cancelado", cls: "bg-slate-100 text-slate-500 border-slate-200" },
};
